export default __webpack_public_path__ + "static/media/background.eb9e35d7.jpg";